import { Moon, Sun } from 'lucide-react';
import { useEffect, useState } from 'react';
import './DarkModeToggle.scss';

export const DarkModeToggle = () => {
  const [darkMode, setDarkMode] = useState(
    localStorage.getItem('darkMode') === 'true'
  );

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark-mode');
      localStorage.setItem('darkMode', 'true');
    } else {
      document.body.classList.remove('dark-mode');
      localStorage.setItem('darkMode', 'false');
    }
  }, [darkMode]);

  return (
    <button
      className="dark-mode-toggle"
      onClick={() => setDarkMode(!darkMode)}
      aria-label="Toggle dark mode"
      data-testid="dark-mode-toggle"
    >
      {darkMode ? <Sun size={20} /> : <Moon size={20} />}
    </button>
  );
};
